import Input from 'components/FormComponents/Input/Input'
import { InputTypes } from '../../lib/enums'
import { Row } from '@tanstack/react-table'

export const EditableTextCell = ({
  inputId,
  value,
  inputType,
  row,
  column: { id },
  maxLength,
  maximumNumber,
  minimumNumber,
  updateCellData,
  isDisabled,
  label,
  inputCreator,
  cssClassNames,
  cameraGroupId,
  hideLabelOnInput
}: EditableTextCellProps) => {
  const handleInputChange = (value: string) => {
    if (inputCreator) {
      updateCellData(row, id, inputCreator(value))
    } else {
      updateCellData(row, id, value)
    }
  }

  return (
    <Input
      id={inputId}
      label={label}
      isSmall
      initialValue={value}
      isDisabled={isDisabled}
      handleDataChange={handleInputChange}
      type={inputType}
      maxLength={maxLength}
      maximumNumber={maximumNumber}
      minimumNumber={minimumNumber}
      className={cssClassNames}
      hideLableOnInput={hideLabelOnInput}
    />
  )
}

type EditableTextCellProps = {
  inputId?: string
  value?: string
  row
  column?: { id: string }
  maxLength?: number
  maximumNumber?: number
  minimumNumber?: number
  updateCellData: (row: Row<any>, columnId: string, value: string) => void
  isDisabled?: boolean
  label?: string
  inputCreator?: (inputValue: string) => any
  inputType?: InputTypes
  cssClassNames?: string
  cameraGroupId?: number
  hideLabelOnInput?: boolean
}
